/** Rebuild disposable exercises when Back crosses a completed mutation. */
import { getInventoryPracticeDataset, relinkInventoryPractice, startInventoryPractice, updateInventoryPracticeCount } from './inventoryPractice';
import { getPracticeDataset } from './practiceDataset';
import { practiceUpdateCostPrice, practiceUpdateSubrecipe } from './practiceGuards';

export function reconstructInventoryExercise(mode: 'inventory' | 'leakage', stepId: string, stepIds: string[]) {
  if (!startInventoryPractice(mode)) return;
  const atOrAfter = (id: string) => stepIds.indexOf(stepId) >= stepIds.indexOf(id);
  const inventory = getInventoryPracticeDataset()!;
  if (mode === 'inventory') {
    if (atOrAfter('inventory-relink-clear')) {
      const assignment = Object.values(inventory.sectionProducts).flat().find(p => p.source === 'custom');
      const target = inventory.availableProducts.find(p => p.productName === assignment?.productName);
      if (assignment && target) relinkInventoryPractice(assignment.id, { productKey: target.productKey, source: 'order' });
    }
    if (atOrAfter('inventory-setup-clear')) {
      const data = getPracticeDataset()!;
      const product = data.orderHistoryList[0].productData[5];
      const subrecipe = data.subrecipesList[0];
      if (subrecipe) practiceUpdateSubrecipe({ id: subrecipe.id, ingredients: [...subrecipe.ingredients, {
        articleId: product.articleId, productName: product.name, platform: 'any_invoice', quantityNeeded: 100, quantityInfo: product.quantityInfo,
      }] });
    }
    if (atOrAfter('inventory-section-count-applied')) {
      const count = inventory.countsHistory[0];
      updateInventoryPracticeCount(count.id, [{ productKey: count.items[0].productKey, count: 1 }]);
    }
    if (atOrAfter('inventory-add-done')) {
      const count = inventory.countsHistory[0];
      const extra = inventory.sectionProducts[count.inventorySectionId!]!.find(p => !count.items.some(item => item.productKey === p.productKey));
      if (extra) updateInventoryPracticeCount(count.id, [{ productKey: extra.productKey, count: 2 }], true);
    }
  } else if (atOrAfter('inventory-leakage-setup-done')) {
    // The missing-recipe product is the stable largest loss in the fixture (mushrooms).
    const data = getPracticeDataset()!;
    const product = data.orderHistoryList[0].productData[5];
    const dish = data.costPriceList[0];
    practiceUpdateCostPrice({ id: dish.id, ingredients: [...dish.ingredients, {
      articleId: product.articleId, productName: product.name, platform: 'any_invoice',
      quantityNeeded: atOrAfter('inventory-leakage-edit-back') ? 50 : 100, quantityInfo: product.quantityInfo,
    }] });
  }
}
